import { useTranslation } from 'react-i18next';
import type { Permission } from '@/api/access/accessApi.types';
import { groupPermissionsByResource } from './groupPermissionsByResource';

interface PermissionSelectorProps {
  permissions: Permission[];
  selectedPermissionIds: string[];
  isReadOnly: boolean;
  onTogglePermission: (permissionId: string) => void;
}

export function PermissionSelector({
  permissions,
  selectedPermissionIds,
  isReadOnly,
  onTogglePermission,
}: PermissionSelectorProps) {
  const { t } = useTranslation('admin');
  const permissionGroups = groupPermissionsByResource(permissions);

  return (
    <div className="space-y-4">
      {permissionGroups.map(function renderGroup(group) {
        return (
          <div key={group.resource}>
            <div className="text-[11px] font-bold uppercase tracking-wider text-zooviolet mb-2">
              {t('permissionResource.' + group.resource, { defaultValue: group.resource })}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {group.permissions.map(function renderPermissionOption(permission) {
                const isSelected = selectedPermissionIds.includes(permission.id);
                return (
                  <label
                    key={permission.id}
                    className="flex items-center gap-2 px-3 py-2 rounded-lg border border-zooborder bg-zoowhite cursor-pointer text-sm"
                  >
                    <input
                      type="checkbox"
                      className="accent-zooprimary"
                      checked={isSelected}
                      disabled={isReadOnly}
                      onChange={function handleToggle() {
                        onTogglePermission(permission.id);
                      }}
                    />
                    <span className="text-zooindigo">
                      {t('permissionAction.' + permission.action, {
                        defaultValue: permission.action,
                      })}
                    </span>
                  </label>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
